import gql from 'graphql-tag';

const groupFields = gql`
  fragment groupFields on Group {
    id
    roomId
    floorId
    name
    displayOrder
    position {
      id
      coordX
      coordY
    }
    startupMode
    fadeIn
    fadeOut
    defaultDimming
    creationDate
    updateDate
    lights {
      ...lightFields
    }
    wizclick1 {
      ...wizclickSettingsFields
    }
    wizclick2 {
      ...wizclickSettingsFields
    }
  }
`;

export default groupFields;
